import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { EffectFade, Autoplay, Pagination, Navigation } from "swiper/modules";
import Logo from "../../../assets/LogoColumn.svg";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import Slide1 from "../../../assets/welcome-slides/WelcomeSlide1.png";
import Slide2 from "../../../assets/welcome-slides/WelcomeSlide2.png";
import Slide3 from "../../../assets/welcome-slides/WelcomeSlide3.png";
import Slide4 from "../../../assets/welcome-slides/WelcomeSlide4.png";
// import LogoIcc from "../../../assets/icc/Logo.svg";
// import Slide1Icc from "../../../assets/icc/WelcomeSlide1.png";
// import Slide2Icc from "../../../assets/icc/WelcomeSlide2.png";
// import Slide3Icc from "../../../assets/icc/WelcomeSlide3.png";
// import Slide4Icc from "../../../assets/icc/WelcomeSlide4.png";
import { useAuth } from "entities/session/model/sessionModel";
import { useTranslation } from "react-i18next";
import { IsVelarApp } from "static/types";
import { Capacitor } from "@capacitor/core";
import { fbLogEvent, FB_EVENTS } from "utils/fbEvents";
import LogoVelar from "../../../assets/velar/Logo.svg";

export const WelcomeScreen = () => {
  const navigate = useNavigate();
  const isAuth = useAuth();
  const { t } = useTranslation("onboarding");
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = IsVelarApp
    ? [{ img: LogoVelar, messageKey: "trackMarkets" }]
    : [
        { img: Slide1, messageKey: "onePlatform" },
        { img: Slide2, messageKey: "lowCostTrading" },
        { img: Slide3, messageKey: "trackMarkets" },
        { img: Slide4, messageKey: "regulatedBroker" },
      ];

  const handleCreateAccount = () => {
    void fbLogEvent(FB_EVENTS.initiatedRegistration);
    navigate(PATH_LIST.chooseAccType);
  };
  const handleLogin = () => {
    navigate(PATH_LIST.login);
  };

  useEffect(() => {
    if (isAuth) handleLogin();
  }, [isAuth]);

  return (
    <div className="auth-welcome">
      {!IsVelarApp && <img className="auth-logo" src={Logo} alt="logo" />}

      <Swiper
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        centeredSlides={true}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        pagination
        modules={[EffectFade, Autoplay, Pagination, Navigation]}
        className="welcome-swiper"
        onSlideChange={(swiper: any) => setActiveIndex(swiper.realIndex)}
        style={{ paddingBottom: Capacitor.isNativePlatform() ? "72px" : "0px" }}
      >
        {slides.map(({ img, messageKey }, idx) => (
          <SwiperSlide key={idx}>
            <img
              className={IsVelarApp ? "velar-welcome-slide-img" : ""}
              src={img}
              alt={`Slide${idx + 1}`}
            />
            {activeIndex === idx ? (
              <span className="welcome-slide-text">{t(messageKey)}</span>
            ) : (
              <div style={{ height: "40px" }}></div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        className="auth-btns"
        style={{
          paddingBottom: Capacitor.isNativePlatform() ? "16px" : "24px",
        }}
      >
        <button onClick={handleCreateAccount}>{t("createAccount")}</button>
        <button onClick={handleLogin}>{t("logIn")}</button>
      </div>
    </div>
  );
};
